import UpdateTitleMiddleware from '@/router/middlewares/UpdateTitle'
import dataOrDefault         from '../utils/dataOrDefault'
import CompanyJson           from '@/models/CompanyJson'
import axios                 from '@/services/axios'
import router                from '@/router'
import _                     from 'lodash'

// Initial state
const state = {
    isLoaded: false,

    // Informações da empresa
    name      : '',
    company_id: '',
    json      : {},

    // Customizações de layout
    ...(new CompanyJson).defaults()
}

// Getters
const getters = {
    state               : state => state,
    isLoaded            : state => state.isLoaded,
    name                : state => state.name,
    company_id          : state => state.company_id,
    program_name        : state => state.program_name,
    hide_cashback       : state => state.hide_cashback,
    hide_points         : state => state.hide_points,

    logo_url            : state => state.logo_url,
    how_works_img       : state => state.how_works_img,
    primary_color       : state => state.primary_color,
    background_color    : state => state.background_color,
    font_color          : state => state.font_color,
    favicon_url         : state => state.favicon_url,
    frontend_domain     : state => state.frontend_domain,
    legal               : state => state.legal,
    
    landing_page_colors : state => state.landing_page_colors,
    home                : state => state.home,
    how_it_works        : state => state.how_it_works,
    description         : state => state.description,
    faq                 : state => state.faq,

    footer              : state => state.footer,
    banner              : state => state.banner,
}

// Mutations
const mutations = {
    SET_COMPANY_DATA(state, data = {}) {
        dataOrDefault(state, data)

        if (!state.home.features.title && data.program_name)
            state.home.features.title = `Conheça o ${data.program_name}`

        if (!state.how_it_works.features.title && data.program_name)
            state.how_it_works.features.title = `Veja como o ${data.program_name} funciona`

        if (state.favicon_url) {
            let favicon = document.querySelector('#favicon-tag')
            favicon && (favicon.href = state.favicon_url)
        }
    },
    SET_IS_LOADED(state, value = false) {
        state.isLoaded = value
    },
    SET_COMPANY_ID(state, value) {
        state.company_id = value
    },
}

// Actions
const actions = {
    async fetchData({ commit }) {
        // Primeiro pega a company id, baseado no domínio atual
        let domain = window.location.hostname

        let response = await axios.get(`company/get-company-by-domain/${domain}`)

        if (!response || !response.data || response.status != 200)
            return
        
        const companyId = response.data[0].company_id

        response = await axios.get(`company/${companyId}`)

        if (!response || !response.data || response.status != 200)
            return

        let company = {
            ...response.data,
            json: (new CompanyJson).completeJson(response.data.json)
        }

        commit('SET_COMPANY_DATA', { ...company.json, ...company })
        commit('SET_COMPANY_ID', companyId)
        commit('SET_IS_LOADED', true)

        // Atualiza o título da página
        let updateTitleMiddleware = new UpdateTitleMiddleware
        updateTitleMiddleware.handle(router.currentRoute, null, null)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
